import React from 'react';
import ImageComparator from 'components/Shared/components/imageComparator';
import {
  exampleSegmentations,
  frameWithSegmentations,
} from 'components/Shared/components/imageComparator/exampleData';

const ImageComparatorExample: React.FC = () => {
  return (
    <ImageComparator
      leftFrame={frameWithSegmentations}
      rightFrame={frameWithSegmentations}
      leftSegmentations={exampleSegmentations}
      rightSegmentations={exampleSegmentations}
      groundTruthSide="left"
    />
  );
};

export default ImageComparatorExample;
